import React, { useEffect } from 'react';
import { ActivityIndicator, View, Alert } from 'react-native';
import { userActions } from '@actions';
import { useDispatch, useSelector } from 'react-redux';
import { offlineStorageSelector, userSelector } from '../../selectors';
import * as Font from 'expo-font';
import * as Device from 'expo-device';
import styles from './styles';
import { BaseColor } from '../../config';
import * as SplashScreen from 'expo-splash-screen';
import { useCallback } from 'react';
import { offlineStorageActions } from '../../redux/actions';
import { AntDesign, Feather, FontAwesome, FontAwesome5, Ionicons, MaterialCommunityIcons, MaterialIcons, Octicons } from '@expo/vector-icons';
SplashScreen.preventAutoHideAsync();
export default function Loading({ navigation }) {
    const dispatch = useDispatch();
    const user = useSelector(userSelector.user);
    const device = useSelector(offlineStorageSelector.device);

    /**
     *
     * Override Alert
     */
    Alert.alert = ({ title, message, action, option, type }) => {
        navigation.navigate('Alert', {
            type: type ?? 'warning',
            title: title ?? '',
            message: message ?? '',
            action,
            option: option ?? { cancelable: true },
        });
    };

    /**
     *
     * Process when open app
     */
    const onProcess = async () => {
        await Font.loadAsync({
            'Montserrat-Black': require('app/assets/fonts/Montserrat-Black.ttf'),
            'Montserrat-Bold': require('app/assets/fonts/Montserrat-Bold.ttf'),
            'Montserrat-Light': require('app/assets/fonts/Montserrat-Light.ttf'),
            'Montserrat-Medium': require('app/assets/fonts/Montserrat-SemiBold.ttf'),
            'Montserrat-Regular': require('app/assets/fonts/Montserrat-Regular.ttf'),
            Montserrat: require('app/assets/fonts/Montserrat-Regular.ttf'),

            ...AntDesign.font,
            ...Feather.font,
            ...FontAwesome.font,
            ...FontAwesome5.font,
            ...Ionicons.font,
            ...MaterialCommunityIcons.font,
            ...MaterialIcons.font,
            ...Octicons.font
        });

        dispatch(
            userActions.clearStorage(false, () => {
                //if (user?.id) {
                //navigate()
                if (!device) {
                    Device.getDeviceTypeAsync().then((response) => {
                        dispatch(offlineStorageActions.simpleUpdate({ device: response }));
                    });
                }
                if (user?.id) {
                    navigate();
                    dispatch(userActions.getUserAuth());
                } else {
                    dispatch(userActions.getUserAuth(navigate));
                }

                // } else {
                //     //navigation.replace('SignIn');
                // }
            })
        );
    };

    let navigate = () => {
        navigation.replace('Main');
    };

    useEffect(() => {
        onProcess();
    }, []);
    const onLayoutRootView = useCallback(async () => {
        //await SplashScreen.hideAsync();
    }, []);

    return (
        <View style={styles.container} onLayout={onLayoutRootView}>
            <View style={{ alignItems: 'center', width: '100%' }}>
                <ActivityIndicator size={'large'} color={BaseColor.primary} />
            </View>
        </View>
    );
}
